import React from 'react'
import {NavLink} from 'reactstrap'
import useSmartNavigate from 'hooks/useSmartNavigate'

const LinkInline = props => {
    const {to, state, disabled, children} = props;
    const navigate = useSmartNavigate();

    const onClick = (e) => {
        e.preventDefault();
        navigate(to, {state: state});
        return false;
    };
    return (
        disabled
        ? <span>{children}</span>
        : <a href={to} onClick={onClick}>{children}</a>);
};

export default LinkInline;